<div class="nsw-in-page-alert nsw-in-page-alert--info">
    <span class="material-icons nsw-material-icons nsw-in-page-alert__icon" focusable="false" aria-hidden="true">info</span>   
    <div class="nsw-in-page-alert__content full-width">
        <ng-container *ngIf="targetSupplied()">
            <div class="title-bar" >
                <a [href]="target">                    
                    <p class="nsw-h5 nsw-text-black" >{{title}}</p>
                </a> 
                <ng-container *ngIf="lastUpdatedDt">
                    <div class="title-bar__lastUpdatedDate">
                        <app-last-updated-widget 
                            label="Last updated" 
                            dateOutFormat="EE, d/M, h aaaaa'm''"                            
                            [updatedDate]="lastUpdatedDt">
                        </app-last-updated-widget>
                    </div>                    
                </ng-container>              
            </div>
        </ng-container>
        
        <ng-container *ngIf="!targetSupplied()">
            <div class="title-bar">
                <p class="nsw-h5 nsw-text-black">{{title}}</p>   
                <ng-container *ngIf="lastUpdatedDt">
                    <div class="title-bar__lastUpdatedDate">
                        <app-last-updated-widget
                            label="Last updated" 
                            dateOutFormat="EE, d/M, h aaaaa'm''"                            
                            [updatedDate]="lastUpdatedDt">
                        </app-last-updated-widget>
                    </div>                    
                </ng-container>                             
            </div>
        </ng-container>
        <p>{{description}}</p>
    </div>
</div>
